import React from "react";
import "./Sec5.css";
import { Link } from "react-router-dom";

function Sec5() {
  return (
    <section className="sec5">
      <div className="innerSec5">
        <div className="mainHeading">Video of Sky Balloons in Action </div>
        <div className="videosSec center">
          <div className="iframe-wrapper">
            <iframe
              src="https://www.youtube.com/embed/QGAMTlI6XxY?si=gC_UpiqZsidAYZIj"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>

          <div className="textpannel">
            <h3>CREATIVE BALLOONS</h3>
            <p>
              Advertising Air Dancers, Hot Air Shape Sky Balloons, Airship Sky
              Balloons.
            </p>
            <div className="text-btn-pan">
              <Link to="https://www.youtube.com/" target="_blank" className="cta">
                {" "}
                watch more
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
export default Sec5;
